import {
    AtualizarObraService,
    CadastrarObraService,
    ConsultarEmpresaService,
    ConsultarObraService,
    DeletarObraService,
    GetObraService,
    ListarObrasService,
} from "../../../Services/Cobranca/Obras/ObrasServices";
import { IObra } from "../../../Interfaces/Cobranca/Obras/ObrasInterfaces";
import { Controller } from "../../Controller";

export async function ListarObrasController() {
    return Controller(ListarObrasService());
}

export async function GetObraController(idCasoCobrancaObra: number) {
    return Controller(GetObraService(idCasoCobrancaObra));
}

export async function AtualizarObraServices(requestBody: IObra) {
    return Controller(AtualizarObraService(requestBody));
}

export async function DeletarObraController(idCasoCobrancaObra: number) {
    return Controller(DeletarObraService(idCasoCobrancaObra));
}

export async function CadastrarObraController(requestBody: IObra) {
    return Controller(CadastrarObraService(requestBody));
}

export async function ConsultarEmpresaController() {
    return Controller(ConsultarEmpresaService());
}

export async function ConsultarObraController(IdEmpresa: number) {
    return Controller(ConsultarObraService(IdEmpresa));
}
